import { render } from "./close-button.vue?vue&type=template&id=0c943137"
import script from "./close-button.vue?vue&type=script&setup=true&lang=js"
export * from "./close-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/close-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c943137"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c943137', __exports__)) {
    api.reload('0c943137', __exports__)
  }
  
  module.hot.accept("./close-button.vue?vue&type=template&id=0c943137", () => {
    api.rerender('0c943137', render)
  })

}


export default __exports__